/* eslint-disable react/prop-types */
import React from 'react';
import { Checkbox, DatePicker, Form, Input, InputNumber, TimePicker } from 'antd';

import Utils from '../../Assets/Scripts/Utils';
import UploadFileField from '../../Pages/ScheduleConecta/Components/UploadFileField';

const { TextArea } = Input;

function isInputDisabled(access, disabled) {
  return Boolean(disabled) || access !== 2;
}

function renderTextInput(disabled) {
  return <Input disabled={disabled} placeholder="o campo está vazio" />;
}

function renderTextArea(disabled) {
  return <TextArea rows={4} disabled={disabled} placeholder="o campo está vazio" />;
}

function renderEmailInput(disabled) {
  return <Input disabled={disabled} placeholder="exemplo@email.com; exemplo2@email.com" />;
}

function renderNumberInput(disabled) {
  return <InputNumber disabled={disabled} placeholder="0" min={0} style={{ width: '100%' }} />;
}

function renderCurrencyInput(disabled) {
  return (
    <InputNumber
      disabled={disabled}
      min={0}
      step={0.0001}
      formatter={Utils.priceFormatter}
      parser={Utils.priceParser}
      style={{ width: '100%' }}
      placeholder="o campo está vazio"
    />
  );
}

function renderDateInput(disabled) {
  return <DatePicker disabled={disabled} format="DD/MM/YYYY" style={{ width: '100%' }} />;
}

function renderTimeInput(disabled) {
  return (
    <TimePicker disabled={disabled} format="HH:mm" style={{ width: '100%', borderRadius: 16 }} />
  );
}

function renderCheckbox(disabled) {
  return <Checkbox disabled={disabled} />;
}

function renderFileInput({
  fieldName,
  access,
  disabled,
  form,
  task,
  handleTaskUpdate,
  setUploadFileType,
  setUploadFileModalOpen,
  isTaskReadOnly,
  isEditing,
}) {
  return (
    <UploadFileField
      handleTaskUpdate={handleTaskUpdate}
      form={form}
      task={task}
      fieldName={fieldName}
      fieldPermission={{ access }}
      isTaskReadOnly={isTaskReadOnly || disabled}
      isEditing={isEditing}
      setUploadFileType={setUploadFileType}
      setUploadFileModalOpen={setUploadFileModalOpen}
      isCustomField
    />
  );
}

function renderFieldControl(fieldType, disabled, fileProps) {
  switch (fieldType) {
    case 'text':
      return renderTextInput(disabled);
    case 'textarea':
      return renderTextArea(disabled);
    case 'email':
      return renderEmailInput(disabled);
    case 'number':
      return renderNumberInput(disabled);
    case 'currency':
      return renderCurrencyInput(disabled);
    case 'date':
      return renderDateInput(disabled);
    case 'time':
      return renderTimeInput(disabled);
    case 'checkbox':
      return renderCheckbox(disabled);
    case 'fileUpload':
      return renderFileInput(fileProps);
    default:
      return renderTextInput(disabled);
  }
}

function CustomFieldInput({
  name,
  label,
  fieldType,
  access,
  disabled,
  form,
  task,
  handleTaskUpdate,
  setUploadFileType,
  setUploadFileModalOpen,
  isTaskReadOnly,
  isEditing,
}) {
  const inputDisabled = isInputDisabled(access, disabled);
  const fieldName = Array.isArray(name) ? name[name.length - 1] : name;
  const emailRules = fieldType === 'email' ? [{ validator: Utils.validateEmails }] : [];

  return (
    <Form.Item
      label={label}
      name={name}
      rules={emailRules}
      valuePropName={fieldType === 'checkbox' ? 'checked' : 'value'}
    >
      {renderFieldControl(fieldType, inputDisabled, {
        fieldName,
        access,
        disabled: inputDisabled,
        form,
        task,
        handleTaskUpdate,
        setUploadFileType,
        setUploadFileModalOpen,
        isTaskReadOnly,
        isEditing,
      })}
    </Form.Item>
  );
}

export default CustomFieldInput;
